module.exports = __webpack_public_path__ + "static/media/number_three_icon_new.81e763e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/number_three_icon_new.svg
// module id = 250
// module chunks = 0